import React from "react";
import Dialog from "../../../../../../components/Dialog/Dialog";
import { Fab, withStyles } from "@material-ui/core";
import CloseIcon from "../../../../../../components/Icon/Close";
import DocumentTextIcon from "../../../../../../components/Icon/DocumentTextIcon";
import DeleteIcon from "../../../../../../components/Icon/DeleteIcon";
import { Button } from "../../../../../../components/ui/Buttons";
import { TextFieldSearch } from "../../../../../../components/TextField";
import InputForm from "../../../../../../components/Input/InputForm";
import { findAllProcedimentos } from "../../../../../../services/ProcedimentoService";
import { findAllProfissionalSaude } from "../../../../../../services/ProfissionalSaudeService";
import CancelIcon from "@material-ui/icons/Cancel";

const ModalIncluirDocumentoAssinado = ({
  classes,
  open,
  onClose,
  documento,
  handleChange,
  handleProcedimentos,
  handleDeleteProcedimentos,
  handleClickIncluirDocumento,
  isLoading,
}) => {
  const useRef = React.useRef(null);

  const handleChangeanexos = (file) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = (e) => {
      const result = e.target.result || "";
      const base64WithoutPrefix = String(result).split("base64,")[1];

      const anexo = {
        nome: file?.name?.split(".")[0],
        extensao: "pdf",
        base64: base64WithoutPrefix,
      };

      handleChange("anexos", anexo);
    };
  };

  const handleClickExcluirAnexo = () => {
    handleChange("anexos", {});
  };

  const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
    try {
      const { content, last } = (
        await findAllProfissionalSaude({
          pageNumber: page,
          search,
        })
      ).data.data.findAllProfissionalSaude;

      return {
        options: content,
        hasMore: !last,
        additional: { page: page + 1 },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const loadAllProcedimentos = async (search, loadedOptions, { page }) => {
    const pageableDTO = {
      pageNumber: page,
      pageSize: 10,
      sortDir: "ASC",
      sortField: "nome",
    };

    const searchDTO = { pageableDTO, nome: search };

    try {
      const { content, last } = (
        await findAllProcedimentos(searchDTO)
      ).data.data.findAllProcedimentos;

      return {
        options: content,
        hasMore: !last,
        additional: { page: page + 1 },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const onDropFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer?.files?.[0];
    if (file) handleChangeanexos(file);
  };

  const disabledButton =
    !documento?.nome || !documento?.anexos?.nome || isLoading;

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.title}>Incluir documento assinado</div>
          <div className={classes.subtitle}>
            Envie o PDF assinado manualmente
          </div>
        </div>

        <Fab id="pac-mda-btn-fch" className={classes.closeButton} onClick={onClose}>
          <CloseIcon color="white" />
        </Fab>
      </div>

      <div className={classes.body}>
        <div className={classes.colLeft}>
          <div className={classes.sectionCard}>
            <div className={classes.sectionTitle}>Dados do documento</div>

            <div className={classes.contentCampos}>
              <span className={classes.titleInput}>Nome do documento</span>
              <InputForm
                id="pac-mda-inp-nom"
                placeholder="Digite o nome do documento"
                value={documento?.nome}
                onChange={(e) => handleChange("nome", e.target.value)}
                classes={{ input: classes.inputInfos, root: classes.rootInput }}
                inputProps={{ maxLength: 100 }}
              />
            </div>

            <div className={classes.contentCampos}>
              <span className={classes.titleInput}>Profissional</span>
              <TextFieldSearch
                id="pac-mda-txt-pro"
                placeholder="Selecione"
                classIcons={classes.classIcons}
                classInput={classes.reactSelect}
                classNotched={classes.notchedOutline}
                loadOptions={loadProfissionaisSaude}
                getOptionLabel={(option) => option?.nome}
                getOptionValue={(option) => option?.id}
                value={documento?.profissionalSaude}
                classes={{ paper: classes.menuHeight }}
                onChange={(e) => handleChange("profissionalSaude", e)}
                withPaginate
                debounceTimeout={300}
                additional={{ page: 0 }}
                menuPosition="fixed"
              />
            </div>

            <div className={classes.contentCampos}>
              <span className={classes.titleInput}>Procedimentos</span>
              <TextFieldSearch
                id="pac-mda-txt-prc"
                classNotched={classes.notchedOutline}
                classInput={classes.reactSelect}
                classIcons={classes.classIcons}
                placeholder={"Selecione o procedimento"}
                onChange={(e, index) => handleProcedimentos(e, index)}
                value={documento.procedimentos}
                menuPlacement={"auto"}
                isClearable
                getOptionLabel={(option) => option.nome}
                getOptionValue={(option) => option.id}
                withPaginate
                loadOptions={loadAllProcedimentos}
                debounceTimeout={300}
                additional={{ page: 0 }}
              />

              <div className={classes.chipsWrap}>
                {documento?.procedimentos?.length > 0 &&
                  documento.procedimentos?.map((item, index) => (
                    <div className={classes.chip} key={index}>
                      <span className={classes.chipText}>
                        {item?.nomeProcedimento || item?.nome}
                      </span>
                      <CancelIcon
                        id={`pac-mda-ico-exc-${index}`}
                        className={classes.chipIcon}
                        onClick={() => handleDeleteProcedimentos(item)}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        <div className={classes.colRight}>
          <div className={classes.sectionCard}>
            <div className={classes.sectionTitle}>Arquivo assinado</div>

            <div
              id="pac-mda-div-drp"
              className={classes.dropzone}
              onClick={() => useRef.current.click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={onDropFile}
              role="button"
              tabIndex={0}
            >
              <div className={classes.dropIcon}>
                <DocumentTextIcon color={"#A0A0A0"} size={46} />
              </div>

              <div className={classes.dropTitle}>Arraste o PDF aqui</div>

              <div className={classes.dropBtnRow}>
                <button
                  id="pac-mda-btn-sel"
                  type="button"
                  className={classes.secondaryBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    useRef.current.click();
                  }}
                >
                  Selecionar arquivo
                </button>
              </div>
            </div>

            {!documento?.anexos?.base64 && (
              <div className={classes.emptySmall}>
                Nenhum arquivo selecionado.
              </div>
            )}

            {documento?.anexos?.base64 && (
              <div className={classes.fileCard}>
                <div className={classes.fileIcon}>
                  <DocumentTextIcon color={"#FB7676"} size={34} />
                </div>

                <div className={classes.fileMeta}>
                  <div className={classes.fileName}>
                    {documento?.anexos?.nome}.pdf
                  </div>
                  <div className={classes.fileSub}>PDF</div>
                </div>

                <div className={classes.fileActions}>
                  <span className={classes.dot}>•</span>

                  <button
                    id="pac-mda-btn-trc"
                    type="button"
                    className={classes.linkBtn}
                    onClick={() => useRef.current.click()}
                  >
                    Trocar
                  </button>

                  <div className={classes.trashWrap}>
                    <DeleteIcon
                      id="pac-mda-ico-del"
                      size={18}
                      color={"#FB7676"}
                      onClick={handleClickExcluirAnexo}
                    />
                  </div>
                </div>
              </div>
            )}

            <input
              id="pac-mda-inp-arq"
              className={classes.inputFile}
              ref={useRef}
              type="file"
              accept=".pdf,application/pdf"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) handleChangeanexos(file);
              }}
            />
          </div>
        </div>
      </div>

      <div className={classes.footer}>
        <Button
          id="pac-mda-btn-add"
          onClick={handleClickIncluirDocumento}
          bgColor={"#0E9F8E"}
          disabled={disabledButton}
        >
          Adicionar documento
        </Button>
      </div>
    </Dialog>
  );
};

const styles = {
  dialog: {
    width: "100%",
    maxWidth: "920px",
    height: "640px",
    overflow: "hidden",
    borderRadius: "18px",
    display: "flex",
    flexDirection: "column",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "22px 24px",
    borderBottom: "1px solid #ECECEC",
    background: "#FFFFFF",
  },

  headerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#1F2937",
  },
  subtitle: {
    fontSize: "14px",
    color: "#6B7280",
  },

  closeButton: {
    height: "44px",
    width: "44px",
    backgroundColor: "#FB7676",
    boxShadow: "0 8px 20px rgba(251, 118, 118, 0.35)",
  },

  body: {
    display: "flex",
    gap: "16px",
    padding: "16px 16px 0 16px",
    flex: 1,
    overflow: "hidden",
    background: "#FFFFFF",
  },

  colLeft: {
    flex: 1,
    minWidth: 0,
    paddingBottom: "16px",
    overflow: "hidden",
  },

  colRight: {
    flex: 1,
    minWidth: 0,
    overflow: "auto",
    paddingBottom: "16px",
  },

  sectionCard: {
    background: "#F7F7F8",
    border: "1px solid #ECECEC",
    borderRadius: "16px",
    padding: "18px",
  },

  sectionTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#1F2937",
    marginBottom: "14px",
  },

  contentCampos: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    textAlign: "left",
    marginBottom: "14px",
  },

  titleInput: {
    color: "#6B7280",
    fontSize: "12px",
    fontWeight: 600,
  },

  inputInfos: {
    color: "#374151",
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    height: "38px",
    boxSizing: "border-box",
    fontSize: "14px",
    borderRadius: "10px",
    padding: "0 12px",
  },

  rootInput: {
    flex: 1,
    minWidth: 0,
    "& .MuiInputBase-root": {
      width: "100%",
    },
  },

  chipsWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    paddingTop: "6px",
    maxHeight: "120px",
    overflow: "auto",
  },

  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    border: "1px solid #D1D5DB",
    background: "#FFFFFF",
    maxWidth: "100%",
  },

  chipText: {
    fontSize: "12px",
    color: "#374151",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "360px",
  },

  chipIcon: {
    color: "#9CA3AF",
    fontSize: "16px",
    cursor: "pointer",
  },

  dropzone: {
    marginTop: "6px",
    background: "#FFFFFF",
    border: "2px dashed #D1D5DB",
    borderRadius: "16px",
    padding: "20px",
    minHeight: "190px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    cursor: "pointer",
    userSelect: "none",
  },

  dropIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "999px",
    background: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  dropTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#374151",
  },

  dropHint: {
    fontSize: "12px",
    color: "#6B7280",
  },

  dropBtnRow: {
    display: "flex",
    gap: "10px",
  },

  emptySmall: {
    marginTop: "12px",
    fontSize: "12px",
    color: "#6B7280",
  },

  fileCard: {
    marginTop: "12px",
    background: "#FFFFFF",
    border: "1px solid #ECECEC",
    borderRadius: "14px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  fileIcon: {
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    background: "rgba(251, 118, 118, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  fileMeta: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },

  fileName: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#111827",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  fileSub: {
    fontSize: "12px",
    color: "#6B7280",
  },

  fileActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  linkBtn: {
    border: "none",
    background: "transparent",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    color: "#505050",
    cursor: "pointer",
  },

  dot: {
    color: "#9CA3AF",
  },

  trashWrap: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },

  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "14px 16px",
    borderTop: "1px solid #ECECEC",
    background: "#FFFFFF",
  },

  secondaryBtn: {
    height: "40px",
    padding: "0 16px",
    borderRadius: "999px",
    border: "1px solid #D1D5DB",
    background: "#FFFFFF",
    color: "#374151",
    fontWeight: 700,
    cursor: "pointer",
  },

  inputFile: {
    display: "none",
  },
};

export default withStyles(styles)(ModalIncluirDocumentoAssinado);
